import {DateTime} from "luxon";

export const expectedDataAvailabilityBoundaryDateTime = (offset: number) => {
    const minute = ((5 * Math.floor( DateTime.utc().minute / 5)) % 60) - offset;
    return DateTime.utc().set({minute: minute}).toJSDate()
}